import Vue from 'vue';
import Router from 'vue-router';
import AppLayout from '@/layouts/app-layout/app-layout.vue';
import AppHeaderLayout from '@/layouts/app-header-layout/app-header-layout.vue';
import { sessionService, SessionService } from '@/providers/services/auth/session';
import access from '@/permission/permission';
import 'pace-progressbar';
import Guest from './views/guest/guest';
import * as LoginPage from 'navigator-widget-ui-component';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: 'network',
    component: AppHeaderLayout,
    children: [
      {
        path: '/network',
        name: 'network',
        component: () => import('@/routers/views/network/network.vue'),
        meta: { isRequiredAuth: true, permission: 'network' },
      },
      {
        path: '/network/countries/:id/:name?',
        name: 'countries-with-state',
        component: () => import('@/routers/views/network/drill-down/drill-down.vue'),
        meta: { isRequiredAuth: true, permission: 'network' },
      },
      {
        path: '/network/:groupType/:name?',
        name: 'countries-with-state-by-name',
        component: () => import('@/routers/views/network/drill-down/drill-down.vue'),
        meta: { isRequiredAuth: true, permission: 'network' },
      },
      {
        path: '/network/partners/type/:type',
        name: 'network-partners-type',
        component: () => import('@/routers/views/network/partners/partners-type/partners-type.vue'),
        meta: { isRequiredAuth: true, permission: 'collaborators' },
      },
      {
        path: '/collaborators/:id',
        name: 'network-partners-profile',
        //  component: () => import('@/routers/views/network/partners/partner-profile/partner-profile.vue'),
        component: () => import('@/routers/views/network/partners/partner-profile-details/partner-profile-details.vue'),
        meta: { isRequiredAuth: true, permission: 'collaborators' },
      },
      {
        path: '/competency',
        name: 'competency',
        redirect: 'competency/competency-map',
      },
      {
        path: '/catalog',
        name: 'catalog',
        beforeEnter() {
          window.location.href = '/research/catalog';
        },
      },
      {
        path: '/learners',
        name: 'learners',
        component: () => import('@/routers/views/learners/learners.vue'),
        meta: {isRequiredAuth: true, permission: 'learners'},
      },
      {
        path: '/learner-identity/:id',
        name: 'learners',
        component: () => import('@/routers/views/learners/learner-identity/learner-identity.vue'),
        meta: {isRequiredAuth: true, permission: 'learners'},
      }
      ,
      {
        path: '/learners/:id',
        name: 'learners-proficiency',
        component: () => {
           // this need to move view
          return import('@/components/proficiency/learner-facets-proficiency/learner-facets-proficiency.vue');
        },
        meta: { isRequiredAuth: true},
      },
      {
        path: '/impact',
        redirect: 'impact-dashboard',
        name: 'impact',
        component: () => import('@/routers/views/impacts/impact.vue'),
        meta: {isRequiredAuth: true, permission: 'impact'},
        children: [
          {
            path: '/impact-dashboard',
            name: 'impact-dashboard',
            component: () => import('@/routers/views/impacts/impact-side-nav/impact-side-nav.vue'),
            meta: {isRequiredAuth: true, permission: 'impact'},
          },
          {
            path: '/impact-performance',
            name: 'impact-performace',
            component: () => import('@/routers/views/impacts/impact-performance/impact-performance.vue'),
            meta: {isRequiredAuth: true, permission: 'impact'},
          },
          {
            path: '/impact-growth',
            name: 'impact-growth',
            component: () => import('@/routers/views/impacts/impact-growth/impact-growth.vue'),
            meta: {isRequiredAuth: true, permission: 'impact'},
          },
          {
            path: '/impact-ela-growth',
            name: 'impact-ela-growth',
            component: () => import('@/routers/views/impacts/impact-ela-growth/impact-ela-growth.vue'),
            meta: {isRequiredAuth: true, permission: 'impact'},
          },
          {
            path: '/impact-attendance',
            name: 'impact-attendance',
            component: () => import('@/routers/views/impacts/impact-attendance/impact-attendance.vue'),
            meta: {isRequiredAuth: true, permission: 'impact'},
          },
          {
            path: '/impact-dashboard-goal',
            name: 'impact-dashboard-goal',
            component: () => import('@/routers/views/impacts/impact-dashboard/impact-dashboard.vue'),
            meta: {isRequiredAuth: true, permission: 'impact'},
          },
        ],
      },
      {
        path: '/console',
        name: 'console',
        component: () => import('@/routers/views/console/console.vue'),
        meta: {isRequiredAuth: true, permission: 'console'},
      },
      {
        path: '/console/:name',
        name: 'console-section',
        component: () => import('@/routers/views/console/lrs/lrs.vue'),
        meta: {isRequiredAuth: true, permission: 'console'},
      },
      {
        path: '/console/impersonate/users',
        name: 'console-impersonate-users',
        component: () => import('@/routers/views/console/impersonate-list/impersonate-list.vue'),
        meta: {isRequiredAuth: true, permission: 'console'},
      },
      {
        path: '/competency/:name',
        name: 'competency-tab-competency-map',
        component: () => import('@/routers/views/competency/competency.vue'),
        meta: {isRequiredAuth: true, permission: 'competency'},
      },
      {
        path: '/projects',
        name: 'research',
        component: () => import('@/routers/views/research/research.vue'),
        meta: {isRequiredAuth: true, permission: 'research'},
      },
      {
        path: '/data-lake',
        name: 'data-lake',
        component: () => import('@/routers/views/data-lake/data-lake.vue'),
        meta: {isRequiredAuth: true, permission: 'data-lake'},
      },
      {
        path: '/data-lake-report',
        name: 'data-lake-report',
        component: () => import('@/routers/views/dl-reports/dl-reports.vue'),
        meta: {isRequiredAuth: true},
        children: [
          {
            path: '',
            name: 'data-lake-dashboard',
            component: () => import('@/routers/views/dl-reports/data-lake-reports/data-lake-reports.vue'),
            meta: {isRequiredAuth: true, permission: 'network'},
          },
          {
            path: 'activities',
            name: 'data-lake-dashboard',
            component: () => import('@/routers/views/dl-reports/activities-table/activities-table.vue'),
            meta: {isRequiredAuth: true, permission: 'network'},
          },
          {
            path: 'student-access-activity',
            name: 'student-access-activity',
            component: () => import('@/routers/views/dl-reports/student-access-activities-table/student-access-activities-table.vue'),
            meta: {isRequiredAuth: true, permission: 'network'},
          },
          {
            path: 'student-summary',
            name: 'student-summary',
            component: () => import('@/routers/views/dl-reports/summary-table/summary-table.vue'),
            meta: {isRequiredAuth: true, permission: 'network'},
          },
        ],
      },
      {
        path: '/tool-providers',
        name: 'learning-registry',
        component: () => import('@/routers/views/data-lake/data-lake.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: '/registry',
        name: 'registry',
        component: () => import('@/routers/views/learner-registry/registry/registry.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: '/collaborators',
        name: 'collaborators',
        component: () => import('@/routers/views/collaborators/collaborators.vue'),
        meta: {isRequiredAuth: true, permission: 'collaborators'},
      },
      {
        path: '/change-password',
        name: 'change-password',
        component: () => import('@/routers/views/change-password/change-password.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import('@/routers/views/profile/profile.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: '/showcase',
        name: 'showcase-page',
        component: () => import('@/routers/views/showcase/showcase.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('@/routers/views/access-error/access-error.vue'),
        meta: {isRequiredAuth: true},
      },
    ],
  },
  {
    path: '/',
    redirect: 'login',
    component: AppLayout,
    children: [
      {
        path: '/guest',
        name: 'guest',
        component: Guest,
      },
      ...LoginPage.routerList(),
      {
        path: '/logout',
        name: 'logout',
        beforeEnter() {
          sessionService.deleteSession();
          window.location.href = '/login';
        },
      },
    ],
  },
];


const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
});


router.beforeEach((to: any, from: any, next) => {
  if (to.meta.isRequiredAuth && !sessionService.isAuthorized()) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
  } else if (to.meta.permission &&  !access.hasMenuAccess(to.meta.permission)) {
    return next({path: `/${access.landingPage()}`});
  } else if (to.meta.isVerifyLogin && sessionService.getMcUpdate()) {
    // Note: if ember js removed no need to use this
    if (sessionService.getMcUpdate().code !== 'DEMO_USER') {
      access.doLoginInWithCredential(sessionService.getMcUpdate());
      return;
    }
    const session = sessionService.getDemoSessionCopy();
    if (session) {
      access.updateRole(session);
    }
  } else if (to.query.isImpersonate) {
    const session = sessionService.getDemoSessionCopy();
    if (session) {
      access.updateRole(session, false).then((landingPage) => {
        next({path: `${landingPage}`});
      });
    }
  }
  next();
});

export default router;
